import axios from "axios";
import { baseUrlUsps } from "../config";
import zod from "zod";
import { msalInstance } from "src/lib/msal";

const uspsApiInstance = axios.create({
    baseURL: baseUrlUsps,
});

uspsApiInstance.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];
        if (account) {
            const { accessToken } = await msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account,
            });

            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

const zipCodeLookupInputSchema = zod.object({
    body: zod.object({
        zipCode: zod.string(),
    }),
});

const zipCodeLookupSchema = zod.object({
    defaultCity: zod.string(),
    defaultState: zod.string(),
    citiesList: zod.array(
        zod.object({ city: zod.string(), state: zod.string() }),
    ),
});

type ZipCodeLookupInput = zod.infer<typeof zipCodeLookupInputSchema>;

async function zipCodeLookup({ body }: ZipCodeLookupInput) {
    const response = await uspsApiInstance.post(
        `/tools/app/ziplookup/cityByZip`,
        `zip=${body.zipCode}`,
        {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
        },
    );

    const validatedResponse = zipCodeLookupSchema.safeParse(response.data);

    if (!validatedResponse.success) {
        throw new Error("Validation of zip code lookup response failed");
    }

    return validatedResponse.data;
}

export const uspsApi = {
    zipCodeLookup,
};
